import React from "react";
import "../App.css";

export const Contact = () => {
  const Mystyle = {
    h1: {
      textAlign: "center",
    },
    contact: {
      display: "flex",
      fontSize: "18px",
      margin: "15px 0px",
      alignItem: "center",
      justifyContent: "center",
      textAlign: "center",
      textDecoration: "none",
      color: "black",
    },
  };
  return (
    <div className="lis-contact">
      <div className="lis-contact_top">
        <h1 style={Mystyle.h1}>LETS GET IN TOUCH</h1>
        <div className=".lis-contact_phone" style={Mystyle.contact}>
          <span>
            <i class="fa fa-phone"></i> Phone: +91 9148945180
          </span>
        </div>
        <div className="lis-contact_email">
          <a
            style={Mystyle.contact}
            href="mailto:lbhari188@gmail.com?subject=Mail from my Website"
          >
            <i class="fa fa-envelope" style={{ marginRight: "0.5em" }}></i> Email:
            lbhari188@gmail.com
          </a>
        </div>
      </div>
      <hr />
      <form
        action="https://formspree.io/f/xeqdzpry"
        className="lis-contact_form"
        method="POST"
      >
        <div className="lis-contact_split">
          <div className="lis-contact_formLeft">
            <input
              type="text"
              name="Name:"
              placeholder="Enter your Name*"
              required
            ></input>

            <input
              type="email"
              name="Email:"
              placeholder="Enter your Email*"
              required
            ></input>
            <input
              type="number"
              name="Phone:"
              placeholder="Enter your Phone Number"
              required
            ></input>
          </div>
          <div className="lis-contact_formRight">
            <textarea
              name="Message:"
              cols="30"
              rows="10"
              placeholder="Enter your message*"
              required
            ></textarea>
          </div>
        </div>
        <button className='lis-contact_btn'>Submit</button>
      </form>
    </div>
  );
};
